// Each article: { slug, categoryId, tags[], contentLoader: { fr, en } }
// contentLoader returns a promise that resolves to a { default: markdownString }

const DOC_REGISTRY = [
  {
    slug: "entrainement-observateurs",
    categoryId: "analysis",
    tags: ["obstraining", "observateur", "video", "qr", "concordance", "observer", "training"],
    contentLoader: {
      fr: () => import("./content/fr/entrainement-observateurs.js"),
      en: () => import("./content/en/entrainement-observateurs.js"),
    },
  },
  {
    slug: "projets-bibliotheque-scientifique",
    categoryId: "analysis",
    tags: ["projet", "temps", "zotero", "bibliographie", "publication", "research", "project"],
    contentLoader: {
      fr: () => import("./content/fr/projets-bibliotheque-scientifique.js"),
      en: () => import("./content/en/projets-bibliotheque-scientifique.js"),
    },
  },
  // ── Getting Started ───────────────────────────────────────
  {
    slug: "premiere-connexion",
    categoryId: "getting-started",
    tags: ["connexion", "dashboard", "accueil", "login"],
    contentLoader: {
      fr: () => import("./content/fr/premiere-connexion.js"),
      en: () => import("./content/en/premiere-connexion.js"),
    },
  },
  {
    slug: "navigation-interface",
    categoryId: "getting-started",
    tags: ["menu", "sidebar", "navigation", "interface"],
    contentLoader: {
      fr: () => import("./content/fr/navigation-interface.js"),
      en: () => import("./content/en/navigation-interface.js"),
    },
  },
  {
    slug: "gestion-compte",
    categoryId: "getting-started",
    tags: ["compte", "langue", "theme", "profil", "role"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-compte.js"),
      en: () => import("./content/en/gestion-compte.js"),
    },
  },
  {
    slug: "offres-et-fonctionnalites",
    categoryId: "getting-started",
    tags: ["offre", "offres", "abonnement", "essentiel", "progress", "evaluation rapide", "cahier", "fonctionnalites", "beta", "offer", "subscription", "plan", "features"],
    contentLoader: {
      fr: () => import("./content/fr/offres-et-fonctionnalites.js"),
      en: () => import("./content/en/offres-et-fonctionnalites.js"),
    },
  },
  {
    slug: "vue-live-timeline",
    categoryId: "getting-started",
    tags: ["live", "temps reel", "timeline", "chronologie", "activite", "suivi", "monitoring", "real-time", "activity", "history", "sector"],
    contentLoader: {
      fr: () => import("./content/fr/vue-live-timeline.js"),
      en: () => import("./content/en/vue-live-timeline.js"),
    },
  },

  // ── Park Management (Secteurs, Enclos, Tournées) ────────
  {
    slug: "organisation-parc",
    categoryId: "park-management",
    tags: ["secteur", "enclos", "animal", "groupe", "tournee", "organisation", "hierarchie"],
    contentLoader: {
      fr: () => import("./content/fr/organisation-parc.js"),
      en: () => import("./content/en/organisation-parc.js"),
    },
  },
  {
    slug: "module-technique-maintenance",
    categoryId: "park-management",
    tags: [
      "technique", "maintenance", "intervention", "panne", "reparation", "cloture",
      "filtration", "securite", "confinement", "remise en service", "acces enclos",
      "technical", "work order", "breakdown", "repair", "fence",
      "safety", "containment", "return to service", "enclosure access",
    ],
    contentLoader: {
      fr: () => import("./content/fr/module-technique-maintenance.js"),
      en: () => import("./content/en/module-technique-maintenance.js"),
    },
  },
  {
    slug: "gestion-enclos",
    categoryId: "park-management",
    tags: ["enclos", "capteur", "secteur", "configuration"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-enclos.js"),
      en: () => import("./content/en/gestion-enclos.js"),
    },
  },
  {
    slug: "transfert-animaux",
    categoryId: "park-management",
    tags: ["transfert", "enclos", "deplacement", "masse"],
    contentLoader: {
      fr: () => import("./content/fr/transfert-animaux.js"),
      en: () => import("./content/en/transfert-animaux.js"),
    },
  },
  {
    slug: "parametres-environnementaux",
    categoryId: "park-management",
    tags: ["environnement", "capteur", "temperature", "humidite", "qualite", "air", "eau", "bassin", "zone", "environment", "sensor", "water", "humidity"],
    contentLoader: {
      fr: () => import("./content/fr/parametres-environnementaux.js"),
      en: () => import("./content/en/parametres-environnementaux.js"),
    },
  },
  {
    slug: "meteo-du-parc",
    categoryId: "park-management",
    tags: ["meteo", "temperature", "pluie", "vent", "ensoleillement", "canicule", "protocole", "seuil", "historique", "weather", "rain", "wind", "heat", "forecast", "protocol"],
    contentLoader: {
      fr: () => import("./content/fr/meteo-du-parc.js"),
      en: () => import("./content/en/meteo-du-parc.js"),
    },
  },
  {
    slug: "badges-et-classement",
    categoryId: "park-management",
    tags: ["badge", "badges", "gamification", "classement", "palmares", "points", "niveau", "xp", "engagement", "motivation", "soigneur", "leaderboard", "hall of fame", "level", "keeper", "reward"],
    contentLoader: {
      fr: () => import("./content/fr/badges-et-classement.js"),
      en: () => import("./content/en/badges-et-classement.js"),
    },
  },
  {
    slug: "creer-gerer-tournee",
    categoryId: "park-management",
    tags: ["tournee", "round", "circuit", "soigneur", "enclos", "creation", "archivage"],
    contentLoader: {
      fr: () => import("./content/fr/creer-gerer-tournee.js"),
      en: () => import("./content/en/creer-gerer-tournee.js"),
    },
  },
  {
    slug: "utiliser-tournee-mobile",
    categoryId: "park-management",
    tags: ["tournee", "round", "mobile", "terrain", "taches", "filtre", "soigneur"],
    contentLoader: {
      fr: () => import("./content/fr/utiliser-tournee-mobile.js"),
      en: () => import("./content/en/utiliser-tournee-mobile.js"),
    },
  },

  // ── Campaigns ─────────────────────────────────────────────
  {
    slug: "creer-campagne",
    categoryId: "campaigns",
    tags: ["campagne", "creation", "evaluation", "questionnaire"],
    contentLoader: {
      fr: () => import("./content/fr/creer-campagne.js"),
      en: () => import("./content/en/creer-campagne.js"),
    },
  },
  {
    slug: "suivre-campagne",
    categoryId: "campaigns",
    tags: ["campagne", "suivi", "monitoring", "progression"],
    contentLoader: {
      fr: () => import("./content/fr/suivre-campagne.js"),
      en: () => import("./content/en/suivre-campagne.js"),
    },
  },
  {
    slug: "exporter-donnees-campagne",
    categoryId: "campaigns",
    tags: ["export", "excel", "csv", "donnees", "campagne"],
    contentLoader: {
      fr: () => import("./content/fr/exporter-donnees-campagne.js"),
      en: () => import("./content/en/exporter-donnees-campagne.js"),
    },
  },
  {
    slug: "visualiser-donnees-collectees",
    categoryId: "campaigns",
    tags: ["donnees", "collecte", "observation", "focal", "scan", "questionnaire", "detail", "score", "comportement", "timeline", "archiver", "formation", "standard", "data", "collected", "view", "behavior"],
    contentLoader: {
      fr: () => import("./content/fr/visualiser-donnees-collectees.js"),
      en: () => import("./content/en/visualiser-donnees-collectees.js"),
    },
  },
  {
    slug: "outils-evaluation",
    categoryId: "getting-started",
    tags: ["ethogramme", "questionnaire", "grille", "evaluation", "taxon", "espece", "focal", "scan", "bien-etre", "comportement", "ethogram", "grid", "species", "welfare", "behavior"],
    contentLoader: {
      fr: () => import("./content/fr/outils-evaluation.js"),
      en: () => import("./content/en/outils-evaluation.js"),
    },
  },
  {
    slug: "campagnes-pedago-training",
    categoryId: "campaigns",
    tags: ["pedago", "pedagogique", "entrainement", "training", "formation", "campagne", "evaluateur", "mode", "standard", "pedagogical", "campaign"],
    contentLoader: {
      fr: () => import("./content/fr/campagnes-pedago-training.js"),
      en: () => import("./content/en/campagnes-pedago-training.js"),
    },
  },
  {
    slug: "contexte-collecte",
    categoryId: "campaigns",
    tags: [
      "contexte", "context", "pre-collecte", "post-collecte", "pre-obs", "post-obs",
      "pre-scan", "post-scan", "pre-collection", "post-collection", "conditions",
      "meteo", "weather", "affluence", "visiteurs", "questionnaire de contexte",
      "focal", "scan", "filtre contexte", "context filter", "export contexte",
    ],
    contentLoader: {
      fr: () => import("./content/fr/contexte-collecte.js"),
      en: () => import("./content/en/contexte-collecte.js"),
    },
  },

  // ── FastEval ──────────────────────────────────────────────
  {
    slug: "creer-grille-evaluation",
    categoryId: "fast-eval",
    tags: ["grille", "evaluation", "creation", "fast-eval", "bien-etre"],
    contentLoader: {
      fr: () => import("./content/fr/creer-grille-evaluation.js"),
      en: () => import("./content/en/creer-grille-evaluation.js"),
    },
  },
  {
    slug: "evaluer-animaux",
    categoryId: "fast-eval",
    tags: ["evaluation", "animaux", "score", "bien-etre"],
    contentLoader: {
      fr: () => import("./content/fr/evaluer-animaux.js"),
      en: () => import("./content/en/evaluer-animaux.js"),
    },
  },
  {
    slug: "groupes-evaluation",
    categoryId: "fast-eval",
    tags: ["groupe", "animaux", "evaluation", "gestion"],
    contentLoader: {
      fr: () => import("./content/fr/groupes-evaluation.js"),
      en: () => import("./content/en/groupes-evaluation.js"),
    },
  },
  {
    slug: "evaluation-rapide-individuelle",
    categoryId: "fast-eval",
    tags: ["evaluation", "individuelle", "individu", "animal", "grille", "tendances", "historique", "pdf", "essentiel", "individual", "evaluation", "trends", "history", "essential"],
    contentLoader: {
      fr: () => import("./content/fr/evaluation-rapide-individuelle.js"),
      en: () => import("./content/en/evaluation-rapide-individuelle.js"),
    },
  },
  {
    slug: "suivi-bien-etre-objectifs-actions",
    categoryId: "fast-eval",
    tags: ["suivi", "bea", "objectif", "action", "decision", "priorite", "consensus", "arbitrage", "revue", "verification", "tache", "follow-up", "welfare", "goal", "decision", "priority", "prioritisation", "review", "verify", "task"],
    contentLoader: {
      fr: () => import("./content/fr/suivi-bien-etre-objectifs-actions.js"),
      en: () => import("./content/en/suivi-bien-etre-objectifs-actions.js"),
    },
  },

  // ── Daily Reports ─────────────────────────────────────────
  {
    slug: "configurer-rapport",
    categoryId: "sectors",
    tags: ["rapport", "secteur", "configuration", "format"],
    contentLoader: {
      fr: () => import("./content/fr/configurer-rapport.js"),
      en: () => import("./content/en/configurer-rapport.js"),
    },
  },
  {
    slug: "parametres-suivis-rapports",
    categoryId: "sectors",
    tags: [
      "rapport", "parametre", "suivi", "tracked", "carnet sante", "carnet environnemental",
      "poids", "body weight", "temperature", "mesure", "measurement", "zims",
      "feature flag", "block kind", "bloc lie",
    ],
    contentLoader: {
      fr: () => import("./content/fr/parametres-suivis-rapports.js"),
      en: () => import("./content/en/parametres-suivis-rapports.js"),
    },
  },
  {
    slug: "remplir-rapport-journalier",
    categoryId: "sectors",
    tags: ["rapport", "journalier", "quotidien", "saisie"],
    contentLoader: {
      fr: () => import("./content/fr/remplir-rapport-journalier.js"),
      en: () => import("./content/en/remplir-rapport-journalier.js"),
    },
  },
  {
    slug: "synthese-consolidee",
    categoryId: "sectors",
    tags: ["synthese", "consolidee", "ia", "rafiki", "resume"],
    contentLoader: {
      fr: () => import("./content/fr/synthese-consolidee.js"),
      en: () => import("./content/en/synthese-consolidee.js"),
    },
  },
  {
    slug: "rafiki-assistant-ia",
    categoryId: "sectors",
    tags: ["rafiki", "ia", "intelligence artificielle", "synthese", "resume", "rapport", "automatique", "chat", "assistant", "ai", "summary", "automatic"],
    contentLoader: {
      fr: () => import("./content/fr/rafiki-assistant-ia.js"),
      en: () => import("./content/en/rafiki-assistant-ia.js"),
    },
  },
  {
    slug: "notes-collaboration",
    categoryId: "sectors",
    tags: ["note", "commentaire", "collaboration", "notification", "equipe", "soigneur", "veterinaire", "role", "email", "reponse", "categorie", "observation", "comment", "team", "keeper", "reply", "category"],
    contentLoader: {
      fr: () => import("./content/fr/notes-collaboration.js"),
      en: () => import("./content/en/notes-collaboration.js"),
    },
  },
  {
    slug: "demandes-reponse-sla",
    categoryId: "sectors",
    tags: [
      "sla", "demande de reponse", "response request", "delai", "deadline",
      "escalade", "escalation", "relance", "reminder", "rappel", "en attente",
      "awaiting", "answered", "cloture", "closed", "note", "role", "notification",
      "chaine de notification", "notification chain", "cloture automatique",
      "auto close", "secteur", "sector", "management", "veterinaire",
    ],
    contentLoader: {
      fr: () => import("./content/fr/demandes-reponse-sla.js"),
      en: () => import("./content/en/demandes-reponse-sla.js"),
    },
  },
  {
    slug: "publier-informations",
    categoryId: "sectors",
    tags: [
      "information", "informations", "communication", "annonce", "announcement",
      "diffusion", "broadcast", "tournee", "tour", "secteur", "sector", "enclos",
      "enclosure", "destinataire", "recipient", "affichage", "tableau d'affichage",
      "notice board", "lecture", "confirmation", "priorite", "priority", "urgent",
    ],
    contentLoader: {
      fr: () => import("./content/fr/publier-informations.js"),
      en: () => import("./content/en/publier-informations.js"),
    },
  },

  // ── Animals ───────────────────────────────────────────────
  {
    slug: "ajouter-animal",
    categoryId: "animals",
    tags: ["animal", "creation", "ajout", "individu"],
    contentLoader: {
      fr: () => import("./content/fr/ajouter-animal.js"),
      en: () => import("./content/en/ajouter-animal.js"),
    },
  },
  {
    slug: "creation-import-animaux",
    categoryId: "animals",
    tags: ["animal", "creation", "import", "zims", "species360", "gan", "masse", "xls", "xlsx", "nemo", "sous-espece", "subspecies", "collection"],
    contentLoader: {
      fr: () => import("./content/fr/creation-import-animaux.js"),
      en: () => import("./content/en/creation-import-animaux.js"),
    },
  },
  {
    slug: "fiche-individu",
    categoryId: "animals",
    tags: ["animal", "fiche", "profil", "individu", "onglets"],
    contentLoader: {
      fr: () => import("./content/fr/fiche-individu.js"),
      en: () => import("./content/en/fiche-individu.js"),
    },
  },
  {
    slug: "gestion-especes",
    categoryId: "animals",
    adminOnly: true,
    tags: ["espece", "taxonomie", "iucn", "ordre", "famille", "species", "latin", "creation", "taxon", "mammifere", "oiseau", "reptile", "liste rouge", "red list", "typesense", "domestique", "domestic", "subspecies", "sous-espece"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-especes.js"),
      en: () => import("./content/en/gestion-especes.js"),
    },
  },
  {
    slug: "entrainement-medical-training",
    categoryId: "animals",
    tags: ["training", "entrainement", "medical training", "husbandry", "conditionnement", "cooperation", "exercice", "seance", "acquisition", "generalisation", "clicker", "target", "eaza", "motivation", "score", "tournee", "exercise", "session", "round", "generalization", "welfare"],
    contentLoader: {
      fr: () => import("./content/fr/entrainement-medical-training.js"),
      en: () => import("./content/en/entrainement-medical-training.js"),
    },
  },
  {
    slug: "doublons-animaux",
    categoryId: "animals",
    tags: ["doublon", "doublons", "fusion", "fusionner", "gan", "puce", "chip", "similarite", "individu", "duplicate", "duplicates", "merge", "similarity"],
    contentLoader: {
      fr: () => import("./content/fr/doublons-animaux.js"),
      en: () => import("./content/en/doublons-animaux.js"),
    },
  },

  // ── Enrichments ───────────────────────────────────────────
  {
    slug: "catalogue-enrichissements",
    categoryId: "enrichments",
    tags: ["enrichissement", "catalogue", "creation"],
    contentLoader: {
      fr: () => import("./content/fr/catalogue-enrichissements.js"),
      en: () => import("./content/en/catalogue-enrichissements.js"),
    },
  },
  {
    slug: "planifier-session",
    categoryId: "enrichments",
    tags: ["session", "enrichissement", "installation", "pose"],
    contentLoader: {
      fr: () => import("./content/fr/planifier-session.js"),
      en: () => import("./content/en/planifier-session.js"),
    },
  },
  {
    slug: "analyser-enrichissements",
    categoryId: "enrichments",
    tags: ["analyse", "enrichissement", "gantt", "performance"],
    contentLoader: {
      fr: () => import("./content/fr/analyser-enrichissements.js"),
      en: () => import("./content/en/analyser-enrichissements.js"),
    },
  },
  {
    slug: "exporter-enrichissements",
    categoryId: "enrichments",
    tags: ["enrichissement", "export", "catalogue", "session", "excel", "csv", "registre", "pdf", "bilan", "registry", "report"],
    contentLoader: {
      fr: () => import("./content/fr/exporter-enrichissements.js"),
      en: () => import("./content/en/exporter-enrichissements.js"),
    },
  },
  {
    slug: "guides-enrichissements",
    categoryId: "enrichments",
    tags: ["guide", "guides", "fabrication", "enrichissement", "communaute", "partage", "vote", "commentaire", "materiel", "etapes", "beta", "building", "community", "sharing", "diy"],
    contentLoader: {
      fr: () => import("./content/fr/guides-enrichissements.js"),
      en: () => import("./content/en/guides-enrichissements.js"),
    },
  },

  // ── Analysis ──────────────────────────────────────────────
  {
    slug: "analyse-questionnaires",
    categoryId: "analysis",
    tags: ["analyse", "questionnaire", "score", "radar", "evolution"],
    contentLoader: {
      fr: () => import("./content/fr/analyse-questionnaires.js"),
      en: () => import("./content/en/analyse-questionnaires.js"),
    },
  },
  {
    slug: "analyse-scan",
    categoryId: "analysis",
    tags: ["scan", "heatmap", "comportement", "spatial", "budget-temps", "social"],
    contentLoader: {
      fr: () => import("./content/fr/analyse-scan.js"),
      en: () => import("./content/en/analyse-scan.js"),
    },
  },
  {
    slug: "analyse-focale",
    categoryId: "analysis",
    tags: ["focal", "comportement", "budget", "sequence", "social"],
    contentLoader: {
      fr: () => import("./content/fr/analyse-focale.js"),
      en: () => import("./content/en/analyse-focale.js"),
    },
  },
  {
    slug: "analyse-multi-parametres",
    categoryId: "analysis",
    tags: [
      "analyse", "multi-parametres", "multi", "croiser", "courbes", "timeseries",
      "scatter", "boxplot", "heatmap", "calendaire", "circadien", "correlation",
      "cohorte", "agregation", "moyenne", "mediane", "vues sauvegardees",
      "export png", "export csv",
      "multi-parameter", "analysis", "cross", "curves", "saved views",
    ],
    contentLoader: {
      fr: () => import("./content/fr/analyse-multi-parametres.js"),
      en: () => import("./content/en/analyse-multi-parametres.js"),
    },
  },
  {
    slug: "concordance-inter-evaluateurs",
    categoryId: "analysis",
    tags: ["concordance", "inter-observateur", "fiabilite", "accord", "calibration", "consensus", "formation", "evaluateur", "reliability", "agreement", "inter-observer", "training"],
    contentLoader: {
      fr: () => import("./content/fr/concordance-inter-evaluateurs.js"),
      en: () => import("./content/en/concordance-inter-evaluateurs.js"),
    },
  },
  {
    slug: "projets-scientifiques",
    categoryId: "analysis",
    tags: [
      "projet scientifique", "recherche", "museo", "musee", "prelevement", "echantillon",
      "jalon", "livrable", "action", "evenement", "anesthesie", "pesee", "autopsie", "deces",
      "eep", "stagiaire", "bilan", "calendrier", "idee", "cahier de secteur",
      "scientific project", "research", "museum", "sampling", "sample", "milestone",
      "deliverable", "event", "anaesthesia", "weighing", "necropsy", "intern", "report",
    ],
    contentLoader: {
      fr: () => import("./content/fr/projets-scientifiques.js"),
      en: () => import("./content/en/projets-scientifiques.js"),
    },
  },

  // ── Tasks ────────────────────────────────────────────────
  {
    slug: "gestion-taches",
    categoryId: "tasks",
    tags: ["tache", "task", "automatisation", "automation", "rappel", "notification", "prescription", "soigneur", "recurrence", "planification"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-taches.js"),
      en: () => import("./content/en/gestion-taches.js"),
    },
  },
  {
    slug: "taches-veterinaires",
    categoryId: "tasks",
    tags: ["tache", "veterinaire", "prescription", "automatisation", "administration", "medicament", "traitement", "soigneur", "task", "veterinary", "medication", "treatment"],
    contentLoader: {
      fr: () => import("./content/fr/taches-veterinaires.js"),
      en: () => import("./content/en/taches-veterinaires.js"),
    },
  },

  // ── Health & Veterinary ──────────────────────────────────
  {
    slug: "suivi-sante",
    categoryId: "health",
    tags: ["sante", "veterinaire", "poids", "temperature", "condition", "dashboard", "suivi", "prescription", "pharmacie", "health", "veterinary", "weight"],
    contentLoader: {
      fr: () => import("./content/fr/suivi-sante.js"),
      en: () => import("./content/en/suivi-sante.js"),
    },
  },
  {
    slug: "gestion-prescriptions",
    categoryId: "health",
    tags: ["prescription", "traitement", "medicament", "pharmacie", "veterinaire", "administration", "renouvellement", "renouveler", "renew", "renewal", "prolongation", "prolonger", "duplicata"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-prescriptions.js"),
      en: () => import("./content/en/gestion-prescriptions.js"),
    },
  },
  {
    slug: "types-ordonnances",
    categoryId: "health",
    tags: ["prescription", "ordonnance", "individuelle", "plusieurs animaux", "multi-animaux", "groupe", "veterinaire", "traitement", "vermifuge", "individual", "several animals", "multi-animal", "group", "veterinary", "treatment"],
    contentLoader: {
      fr: () => import("./content/fr/types-ordonnances.js"),
      en: () => import("./content/en/types-ordonnances.js"),
    },
  },

  // ── Admin ─────────────────────────────────────────────────
  {
    slug: "parametres-personnalises-partage",
    categoryId: "admin",
    tags: [
      "parametre personnalise", "custom parameter", "visibilite", "visibility",
      "partage", "sharing", "prive", "private", "partage", "shared", "tout le parc",
      "zoo", "secteur", "sector", "sante", "environnement", "health", "environmental",
      "hub", "createur", "veterinaire", "droits", "gouvernance",
    ],
    contentLoader: {
      fr: () => import("./content/fr/parametres-personnalises-partage.js"),
      en: () => import("./content/en/parametres-personnalises-partage.js"),
    },
  },
  {
    slug: "parametres-zoo",
    categoryId: "admin",
    tags: ["parametres", "zoo", "configuration", "fuseau"],
    contentLoader: {
      fr: () => import("./content/fr/parametres-zoo.js"),
      en: () => import("./content/en/parametres-zoo.js"),
    },
  },
  {
    slug: "gestion-utilisateurs",
    categoryId: "admin",
    tags: ["utilisateur", "role", "permission", "equipe"],
    contentLoader: {
      fr: () => import("./content/fr/gestion-utilisateurs.js"),
      en: () => import("./content/en/gestion-utilisateurs.js"),
    },
  },
  {
    slug: "synchro-zims",
    categoryId: "admin",
    // ZIMS n'existe pas pour un laboratoire (issue #1096).
    zimsOnly: true,
    tags: ["zims", "species360", "synchronisation", "poids", "sante", "gan", "weight", "sync"],
    contentLoader: {
      fr: () => import("./content/fr/synchro-zims.js"),
      en: () => import("./content/en/synchro-zims.js"),
    },
  },
  {
    slug: "tickets-support",
    categoryId: "admin",
    tags: ["support", "ticket", "aide", "bug", "demande", "contact", "notification", "tache"],
    contentLoader: {
      fr: () => import("./content/fr/tickets-support.js"),
      en: () => import("./content/en/tickets-support.js"),
    },
  },
  {
    slug: "logiques-traduction",
    categoryId: "admin",
    adminOnly: true,
    tags: [
      "traduction", "translation", "deepl", "cache", "langue", "language",
      "revision", "relecture", "review", "pointage", "approbation", "sign-off",
      "remontee", "source", "banque de questions", "question bank",
      "questionnaire", "ethogramme", "ethogram", "contexte", "context",
      "version", "snapshot", "campagne", "campaign", "proposition", "proposal",
    ],
    contentLoader: {
      fr: () => import("./content/fr/logiques-traduction.js"),
      en: () => import("./content/en/logiques-traduction.js"),
    },
  },
];

export default DOC_REGISTRY;
